



































































































































































































































import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Airline, Booking, User } from '@/api';
import { apiBase, apiNamespace } from '@/config';

interface DiaryTime {
  time: string;
  flights: DiaryFlight[];
}
interface DiaryFlight {
  airline: string;
  flight: string;
  people: number;
  bookings: Booking[];
}

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;

  diaryDateMenu: boolean = false;
  diaryDate: string = moment().format('YYYY-MM-DD');
  bookings: Booking[] | null = null;
  sortedBookings: DiaryTime[] = [];

  invoiceUrl(booking: Booking) {
    return apiBase + apiNamespace + '/bookings/' + booking.id + '/invoice/';
  }

  get formattedDiaryDate() {
    if (!this.diaryDate) {
      return '';
    }
    return moment(this.diaryDate, 'YYYY-MM-DD').format('ddd, D MMMM YYYY');
  }

  get bookingStartPdf() {
    return (
      apiBase +
      apiNamespace +
      '/bookings/invoices/?filter[status]=complete&filter[start_diary_date]=' +
      this.diaryDate
    );
  }

  get bookingEndPdf() {
    return (
      apiBase +
      apiNamespace +
      '/bookings/invoices/?filter[status]=complete&filter[end_diary_date]=' +
      this.diaryDate
    );
  }

  prevDate() {
    this.diaryDate = moment(this.diaryDate, 'YYYY-MM-DD')
      .subtract(1, 'day')
      .format('YYYY-MM-DD');
  }

  nextDate() {
    this.diaryDate = moment(this.diaryDate, 'YYYY-MM-DD')
      .add(1, 'day')
      .format('YYYY-MM-DD');
  }

  pluralise(count: number, noun: string, pluralNoun: string) {
    return `${count} ${count === 1 ? noun : pluralNoun}`;
  }

  bookingTypeClass(booking: Booking, time: string) {
    const startDate = moment(booking.startDatetime).format('YYYY-MM-DD');
    const startTime = booking.busDepartureTime
      ? moment(booking.busDepartureTime, 'HH:mm:ss').format('HH:mm')
      : moment(booking.startDatetime).format('HH:mm');
    const endDate = moment(booking.endDatetime).format('YYYY-MM-DD');
    const endTime = moment(booking.endDatetime).format('HH:mm');

    if (startDate === this.diaryDate && startTime === time) {
      return {
        'diary-table__booking--departing': true,
      };
    } else if (endDate === this.diaryDate && endTime === time) {
      return {
        'diary-table__booking--arriving': true,
      };
    }
  }

  peopleCount(booking: Booking, time: string) {
    const startDate = moment(booking.startDatetime).format('YYYY-MM-DD');
    const startTime = booking.busDepartureTime
      ? moment(booking.busDepartureTime, 'HH:mm:ss').format('HH:mm')
      : moment(booking.startDatetime).format('HH:mm');
    const endDate = moment(booking.endDatetime).format('YYYY-MM-DD');
    const endTime = moment(booking.endDatetime).format('HH:mm');

    if (startDate === this.diaryDate && startTime === time) {
      return booking.passengersOut;
    } else if (endDate === this.diaryDate && endTime === time) {
      return booking.passengersIn;
    }
  }

  async updateDiary() {
    try {
      this.loading = true;
      this.bookings = (
        await Booking.includes(['airlineOut', 'airlineIn', 'lot'])
          .where({ diaryDate: this.diaryDate, status: 'complete' })
          .per(1000)
          .all()
      ).data;
      this.sortedBookings = this.bookings.reduce(
        (a: DiaryTime[], b: Booking) => {
          const startDate = moment(b.startDatetime).format('YYYY-MM-DD');
          const endDate = moment(b.endDatetime).format('YYYY-MM-DD');

          const buildObj = (
            sortedObj: DiaryTime[],
            airlineObj: Airline,
            flightNumber: string,
            bookingTime: string,
            bookingType: string,
          ) => {
            let peopleNumber = 0;
            if (bookingType === 'departing') {
              peopleNumber = b.passengersOut;
            } else if (bookingType === 'arriving') {
              peopleNumber = b.passengersIn;
            }
            const existingTime = sortedObj.find(
              (item: DiaryTime) => item.time === bookingTime,
            );
            if (existingTime) {
              const existingFlight = existingTime.flights.find(
                (item: DiaryFlight) => item.flight === flightNumber,
              );
              if (existingFlight) {
                existingFlight.people = existingFlight.people + peopleNumber;
                existingFlight.bookings.push(b);
              } else {
                const flightObj: DiaryFlight = {
                  airline: airlineObj.name,
                  flight: flightNumber,
                  people: peopleNumber,
                  bookings: [],
                };

                flightObj.bookings.push(b);
                existingTime.flights.push(flightObj);
              }
            } else {
              if (bookingTime) {
                const timeObj: DiaryTime = { time: bookingTime, flights: [] };

                const flightObj: DiaryFlight = {
                  airline: airlineObj.name,
                  flight: flightNumber,
                  people: peopleNumber,
                  bookings: [],
                };

                flightObj.bookings.push(b);
                timeObj.flights.push(flightObj);

                sortedObj.push(timeObj);
              }
            }
          };

          if (startDate === this.diaryDate) {
            const airline = b.airlineOut;
            const flightNumber = b.flightNumberOut;
            const bookingTime = b.busDepartureTime
              ? moment(b.busDepartureTime, 'HH:mm:ss').format('HH:mm')
              : moment(b.startDatetime).format('HH:mm');
            buildObj(a, airline, flightNumber, bookingTime, 'departing');
          }
          if (
            endDate === this.diaryDate &&
            b.airlineIn &&
            b.flightNumberIn &&
            b.endDatetime
          ) {
            const airline = b.airlineIn;
            const flightNumber = b.flightNumberIn;
            const bookingTime = moment(b.endDatetime).format('HH:mm');
            buildObj(a, airline, flightNumber, bookingTime, 'arriving');
          }

          return a;
        },
        [],
      );
      this.sortedBookings.sort((a, b) =>
        moment(a.time, 'HH:mm').diff(moment(b.time, 'HH:mm')),
      );
    } catch (err) {
      // Error
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    if (this.$route.query.diary_date) {
      this.diaryDate = moment(this.$route.query.diary_date.toString()).format(
        'YYYY-MM-DD',
      );
    }
    this.updateDiary();
  }

  @Watch('diaryDate')
  dateChanged() {
    this.updateDiary();
    this.$router.replace({
      name: 'admin-diary',
      query: { diary_date: this.diaryDate },
    });
  }
}
